import type { RouteRecordRaw } from 'vue-router'

export const adminAuthorsRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/authors',
    name: 'admin-authors',
    component: () => import('./pages/AdminAuthorsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
]
